function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { COMMON_PROPERTIES$1, ADVANCED_PROPERTIES$1, EVENT_PROPERTIES$1, zhLocale_extension, enLocale_extension } from './charts/configData';
export function isNull(o) {
  return o == null;
}
export function isNotNull(o) {
  return o != null;
}
export function isEmptyStr(o) {
  return o === void 0 || !o && o !== 0 && o !== '0' || !/[^\s]/.test(o);
}
export function generateId() {
  return Math.floor(Math.random() * 1e5 + Math.random() * 2e4 + Math.random() * 5e3);
}
export function deepClone(o) {
  if (o !== void 0) return JSON.parse(JSON.stringify(o));
}
export function overwriteObj(o, e) {
  Object.keys(e).forEach(function (n) {
    o[n] = e[n];
  });
}
export function evalFn(o) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return new Function('DSV', 'VFR', 'LS', 'formulaJs', 'return ' + o)(e, n, localStorage, l);
}
export function trimEx(o, e, n) {
  return e ? n === 'left' ? o.replace(new RegExp('^\\' + e + '+', 'g'), '') : n === 'right' ? o.replace(new RegExp('\\' + e + '+$', 'g'), '') : o.replace(new RegExp('^\\' + e + '+|\\' + e + '+$', 'g'), '') : o.replace(/^\s+|\s+$/g, '');
}
export function hasPropertyOfObject(o, e) {
  var n = e.split('.');
  var l = o,
    s = !0;
  var _iterator = _createForOfIteratorHelper(n),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var c = _step.value;
      if (l.hasOwnProperty(c)) l = l[c];else {
        s = !1;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return s;
}
export function objectKeysToArray(o) {
  if (!o) return [];
  var e = [];
  return Object.keys(o).forEach(function (n) {
    e.push(n);
  }), e;
}
export function isDef(o) {
  return o != null;
}
export function getObjectValue(o, e) {
  var n = e.split('.');
  var l = o;
  return n.forEach(function (s) {
    l = isDef(l) && isDef(l[s]) ? l[s] : null;
  }), l;
}
export function setObjectValue(o, e, n) {
  var l = e.split('.');
  var s = o;
  l.forEach(function (c, u) {
    if (!!c) {
      if (u === l.length - 1) {
        s[c] = n;
        return;
      }
      s[c] === void 0 && (s[c] = {}), s = s[c];
    }
  });
}
export function addWindowResizeHandler(o) {
  var e = window.onresize;
  typeof window.onresize != 'function' ? window.onresize = o : window.onresize = function () {
    e(), o();
  };
}
export function insertCustomCssToHead(o) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var n = document.getElementsByTagName('head')[0];
  var l = document.getElementById('vform-custom-css');
  l && n.removeChild(l), e && (l = document.getElementById('vform-custom-css-' + e), !!l && n.removeChild(l));
  var s = document.createElement('style');
  s.type = 'text/css', s.rel = 'stylesheet', s.id = e ? 'vform-custom-css-' + e : 'vform-custom-css';
  try {
    s.appendChild(document.createTextNode(o));
  } catch (_unused) {
    s.styleSheet.cssText = o;
  }
  n.appendChild(s);
}
export function insertGlobalFunctionsToHtml(o) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var n = document.getElementsByTagName('body')[0];
  var l = document.getElementById('v_form_global_functions');
  !!l && n.removeChild(l), e && (l = document.getElementById('v_form_global_functions-' + e), !!l && n.removeChild(l));
  var s = document.createElement('script');
  s.id = e ? 'v_form_global_functions-' + e : 'v_form_global_functions', s.type = 'text/javascript', s.innerHTML = o, n.appendChild(s);
}
export function deleteCustomStyleAndScriptNode(o, e) {
  var n = document.getElementsByTagName('head')[0];
  var l = document.getElementById('vform-custom-css-' + e);
  o && (l = document.getElementById('vform-custom-css')), l && n.removeChild(l);
  var s = document.getElementsByTagName('body')[0];
  var c = document.getElementById('v_form_global_functions-' + e);
  o && (c = document.getElementById('v_form_global_functions')), c && s.removeChild(c);
}
export function optionExists(o, e) {
  return o ? Object.keys(o).indexOf(e) > -1 : !1;
}
export function loadRemoteScript(o, e) {
  var n = encodeURIComponent(o);
  if (!document.getElementById(n)) {
    var s = document.createElement('script');
    s.src = o, s.id = n, document.body.appendChild(s), s.onload = s.onreadystatechange = function (c, u) {
      ;
      (u || !s.readyState || s.readyState === 'loaded' || s.readyState === 'complete') && (s = s.onload = s.onreadystatechange = null, u || e());
    };
  }
}
export function traverseFieldWidgets(o, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  !o || o.map(function (s) {
    s.formItemFlag || s.formItemFlag === !1 && l ? e(s, n) : s.type === 'grid' ? s.cols.map(function (c) {
      traverseFieldWidgets(c.widgetList, e, s, l);
    }) : s.type === 'table' ? s.rows.map(function (c) {
      c.cols.map(function (u) {
        traverseFieldWidgets(u.widgetList, e, s, l);
      });
    }) : s.type === 'tab' ? s.tabs.map(function (c) {
      traverseFieldWidgets(c.widgetList, e, s, l);
    }) : (s.type === 'sub-form' || s.type === 'grid-sub-form' || s.category === 'container') && traverseFieldWidgets(s.widgetList, e, s, l);
  });
}
export function traverseContainerWidgets(o, e) {
  !o || o.map(function (n) {
    n.category === 'container' && e(n), n.type === 'grid' ? n.cols.map(function (l) {
      traverseContainerWidgets(l.widgetList, e);
    }) : n.type === 'table' ? n.rows.map(function (l) {
      l.cols.map(function (s) {
        traverseContainerWidgets(s.widgetList, e);
      });
    }) : n.type === 'tab' ? n.tabs.map(function (l) {
      traverseContainerWidgets(l.widgetList, e);
    }) : (n.type === 'sub-form' || n.type === 'grid-sub-form' || n.category === 'container') && traverseContainerWidgets(n.widgetList, e);
  });
}
export function traverseAllWidgets(o, e) {
  !o || o.map(function (n) {
    e(n), n.type === 'grid' ? n.cols.map(function (l) {
      e(l), traverseAllWidgets(l.widgetList, e);
    }) : n.type === 'table' ? n.rows.map(function (l) {
      l.cols.map(function (s) {
        e(s), traverseAllWidgets(s.widgetList, e);
      });
    }) : n.type === 'tab' ? n.tabs.map(function (l) {
      traverseAllWidgets(l.widgetList, e);
    }) : (n.type === 'sub-form' || n.type === 'grid-sub-form' || n.category === 'container') && traverseAllWidgets(n.widgetList, e);
  });
}
export function handleWidgetForTraverse(o, e) {
  !!o.category && o.category === 'container' ? traverseFieldWidgetsOfContainer(o, e) : o.formItemFlag && e(o);
}
export function traverseFieldWidgetsOfContainer(o, e) {
  o.type === 'grid' ? o.cols.forEach(function (n) {
    n.widgetList.forEach(function (l) {
      handleWidgetForTraverse(l, e);
    });
  }) : o.type === 'table' ? o.rows.forEach(function (n) {
    n.cols.forEach(function (l) {
      l.widgetList.forEach(function (s) {
        handleWidgetForTraverse(s, e);
      });
    });
  }) : o.type === 'tab' ? o.tabs.forEach(function (n) {
    n.widgetList.forEach(function (l) {
      handleWidgetForTraverse(l, e);
    });
  }) : o.type === 'sub-form' || o.type === 'grid-sub-form' ? o.widgetList.forEach(function (n) {
    handleWidgetForTraverse(n, e);
  }) : o.category === 'container' && o.widgetList.forEach(function (n) {
    handleWidgetForTraverse(n, e);
  });
}
export function handleContainerTraverse(o, e, n, l, s) {
  !!o.category && o.category === 'container' ? traverseWidgetsOfContainer(o, e, n, l, s) : (o.formItemFlag || s) && e(o);
}
export function traverseWidgetsOfContainer(o, e, n, l, s) {
  o.category === 'container' && n(o), o.type === 'grid' ? o.cols.forEach(function (c) {
    l && n(c), c.widgetList.forEach(function (u) {
      handleContainerTraverse(u, e, n, l, s);
    });
  }) : o.type === 'table' ? o.rows.forEach(function (c) {
    l && n(c), c.cols.forEach(function (u) {
      l && n(u), u.widgetList.forEach(function ($) {
        handleContainerTraverse($, e, n, l, s);
      });
    });
  }) : o.type === 'tab' ? o.tabs.forEach(function (c) {
    l && n(c), c.widgetList.forEach(function (u) {
      handleContainerTraverse(u, e, n, l, s);
    });
  }) : o.type === 'sub-form' || o.type === 'grid-sub-form' ? o.widgetList.forEach(function (c) {
    handleContainerTraverse(c, e, n, l, s);
  }) : o.category === 'container' && o.widgetList.forEach(function (c) {
    handleContainerTraverse(c, e, n, l, s);
  });
}
export function traverseWidgetsOfGridCol(o, e, n) {
  o.type === 'grid-col' && o.widgetList.forEach(function (l) {
    handleContainerTraverse(l, e, n);
  });
}
export function getAllFieldWidgets(o) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  if (!o) return [];
  var n = [];
  return traverseFieldWidgets(o, function (s) {
    n.push({
      type: s.type,
      name: s.options.name,
      field: s
    });
  }, null, e), n;
}
export function getAllContainerWidgets(o) {
  if (!o) return [];
  var e = [];
  return traverseContainerWidgets(o, function (l) {
    e.push({
      type: l.type,
      name: l.options.name,
      container: l
    });
  }), e;
}
export function getFieldWidgetByName(o, e, n) {
  if (!o) return null;
  var l = null;
  return traverseFieldWidgets(o, function (c) {
    c.options.name === e && (l = c);
  }, null, n), l;
}
export function getFieldWidgetById(o, e, n) {
  if (!o) return null;
  var l = null;
  return traverseFieldWidgets(o, function (c) {
    c.id === e && (l = c);
  }, null, n), l;
}
export function getSubFormNameByFieldId(o, e) {
  var n = null;
  return getAllContainerWidgets(o).forEach(function (s) {
    var c = function c(u) {
      u.id === e && (n = s.name);
    };
    (s.type === 'sub-form' || s.type === 'grid-sub-form') && traverseFieldWidgetsOfContainer(s.container, c);
  }), n;
}
export function getContainerWidgetByName(o, e) {
  if (!o) return null;
  var n = null;
  return traverseContainerWidgets(o, function (s) {
    s.options.name === e && (n = s);
  }), n;
}
export function getContainerWidgetById(o, e) {
  if (!o) return null;
  var n = null;
  return traverseContainerWidgets(o, function (s) {
    s.id === e && (n = s);
  }), n;
}
export function copyToClipboard(o, e, n, l, s) {
  var c = new Clipboard(e.target, {
    text: function text() {
      return o;
    }
  });
  c.on('success', function () {
    n.success(l), c.destroy();
  }), c.on('error', function () {
    n.error(s), c.destroy();
  }), c.onClick(e);
}
export function getQueryParam(o) {
  var n = window.location.search.substring(1).split('&');
  for (var l = 0; l < n.length; l++) {
    var s = n[l].split('=');
    if (s[0] == o) return s[1];
  }
}
export function getDefaultFormConfig() {
  return {
    modelName: 'formData',
    refName: 'vForm',
    rulesName: 'rules',
    labelWidth: 80,
    labelPosition: 'left',
    size: '',
    labelAlign: 'label-left-align',
    cssCode: '',
    customClass: [],
    functions: '',
    layoutType: 'PC',
    jsonVersion: 3,
    dataSources: [],
    onFormCreated: '',
    onFormMounted: '',
    onFormDataChange: '',
    onFormValidate: ''
  };
}
export function buildDefaultFormJson() {
  return {
    widgetList: [],
    formConfig: deepClone(getDefaultFormConfig())
  };
}
export function cloneFormConfigWithoutEventHandler(o) {
  var e = deepClone(o);
  return e.onFormCreated = '', e.onFormMounted = '', e.onFormDataChange = '', e.onFormValidate = '', e;
}
export function translateOptionItems(o, e, n, l) {
  if (e === 'cascader') return deepClone(o);
  var s = [];
  return !!o && o.length > 0 && o.forEach(function (c) {
    c.hasOwnProperty('disabled') ? s.push({
      label: c[n],
      value: c[l],
      disabled: c.disabled
    }) : s.push({
      label: c[n],
      value: c[l]
    });
  }), s;
}
export function assembleAxiosConfig(o, e, n) {
  var l = {};
  return !o || o.length <= 0 || (o.map(function (s) {
    s.type === 'String' ? l[s.name] = String(s.value) : s.type === 'Number' ? l[s.name] = Number(s.value) : s.type === 'Boolean' ? s.value.toLowerCase() === 'false' || s.value === '0' ? l[s.name] = !1 : s.value.toLowerCase() === 'true' || s.value === '1' ? l[s.name] = !0 : l[s.name] = null : s.type === 'Variable' && (l[s.name] = evalFn(s.value, e, n));
  }), console.log('test DSV: ', e), console.log('test VFR: ', n)), l;
}
export function buildRequestConfig(o, e, n, l) {
  var s = {};
  return o.requestURLType === 'String' ? s.url = o.requestURL : s.url = evalFn(o.requestURL, e, n), s.method = o.requestMethod, s.headers = assembleAxiosConfig(o.headers, e, n), s.params = assembleAxiosConfig(o.params, e, n), s.data = assembleAxiosConfig(o.data, e, n), new Function('config', 'isSandbox', 'DSV', 'VFR', o.configHandlerCode).call(null, s, l, e, n);
}
export function runDataSourceRequest(_x, _x2, _x3, _x4, _x5) {
  return _runDataSourceRequest.apply(this, arguments);
}
function _runDataSourceRequest() {
  _runDataSourceRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(o, e, n, l, s) {
    var c, u, _u;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          c = buildRequestConfig(o, e, n, l);
          _context.next = 4;
          return axios.request(c);
        case 4:
          u = _context.sent;
          return _context.abrupt("return", new Function('result', 'isSandbox', 'DSV', 'VFR', o.dataHandlerCode).call(null, u, l, e, n));
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _u = new Function('error', 'isSandbox', 'DSV', '$message', 'VFR', o.errorHandlerCode);
          return _context.abrupt("return", (console.error(_context.t0), _u.call(null, _context.t0, l, e, s, n)));
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _runDataSourceRequest.apply(this, arguments);
}
export function getDSByName(o, e) {
  var n = null;
  return !!e && !!o.dataSources && o.dataSources.forEach(function (l) {
    l.uniqueName === e && (n = l);
  }), n || console.error('DS not found: ' + e), n;
}
export function addZHExtensionLang(o) {
  !!o.extension && !!o.extension.widgetLabel && overwriteObj(zhLocale_extension.extension.widgetLabel, o.extension.widgetLabel), !!o.extension && !!o.extension.setting && overwriteObj(zhLocale_extension.extension.setting, o.extension.setting);
}
export function addENExtensionLang(o) {
  !!o.extension && !!o.extension.widgetLabel && overwriteObj(enLocale_extension.extension.widgetLabel, o.extension.widgetLabel), !!o.extension && !!o.extension.setting && overwriteObj(enLocale_extension.extension.setting, o.extension.setting);
}
var WidgetProperties = {
  COMMON_PROPERTIES: COMMON_PROPERTIES$1,
  ADVANCED_PROPERTIES: ADVANCED_PROPERTIES$1,
  EVENT_PROPERTIES: EVENT_PROPERTIES$1
};
export var PERegister = Object.freeze(Object.defineProperty({
  __proto__: null,
  registerCommonProperty: registerCommonProperty,
  registerAdvancedProperty: registerAdvancedProperty,
  registerEventProperty: registerEventProperty,
  propertyRegistered: propertyRegistered,
  registerCPEditor: registerCPEditor,
  registerAPEditor: registerAPEditor,
  registerEPEditor: registerEPEditor,
  default: WidgetProperties
}, Symbol.toStringTag, {
  value: 'Module'
}));
function registerCommonProperty(o, e) {
  COMMON_PROPERTIES$1[o] = e;
}
function registerAdvancedProperty(o, e) {
  ADVANCED_PROPERTIES$1[o] = e;
}
function registerEventProperty(o, e) {
  EVENT_PROPERTIES$1[o] = e;
}
export function propertyRegistered(o) {
  return !!COMMON_PROPERTIES$1[o] || !!ADVANCED_PROPERTIES$1[o] || !!EVENT_PROPERTIES$1[o];
}
function registerCPEditor(o, e, n, l) {
  o.component(n, l), registerCommonProperty(e, n);
}
function registerAPEditor(o, e, n, l) {
  o.component(n, l), registerAdvancedProperty(e, n);
}
function registerEPEditor(o, e, n, l) {
  o.component(n, l), registerEventProperty(e, n);
}
export function addChartContainerSchema(o) {
  chartContainers.push(o);
}